"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  marine: {
    vesselName: 'Vessel Name',
    statisticsName: 'Statistics',
    common: {
      closeTrack: 'Close Track',
      activateTrack: 'Activate Track',
      diversity: 'Diversity',
      invalid: 'Invalid',
      reset: 'Reset',
      add: 'Add',
      save: 'Save',
      submit: 'Submit',
      operation: 'Option',
      correct: 'Revised',
      completed: 'Completed',
      nextStep: 'Next Step',
      uploadTitle: 'Upload Attachment',
      attach: 'Attachment',
      abstract: 'Remark',
      serialnumber: 'No.',
      fileName: 'Attachment',
      uploadTime: 'Time',
      uploadDepartment: 'Department',
      uploadedBy: 'Operator',
      status: 'Status',
      voyageVersion: 'Voyage Version',
      willForm: 'The form is required',
      pleaseWait: 'Please wait while the process starts！',
      startingSuccess: 'Start Successfully',
      deadStart: 'Failed to Start',
      unclosedReport: 'Please fill in end of typhoon or end of frog'
    },
    prompt: {
      confirmDel: 'Are you sure you want to delete',
      pleaseInput: 'Please Enter',
      pleaseInputNum: 'Please Enter Number',
      pleaseInputDate: 'Please Enter Date',
      pleaseAttachment: 'Please Select File',
      pleaseFirstSave: 'Please Save firstly',
      submitAgain: 'Don’t Submit Repeatedly',
      saveAgain: 'Don’t Save Repeatedly',
      versions: 'The latest version is inconsistent with the previous version. Please adjust it before modifying it',
      selectAuditTips: 'Please Select Approval!',
      selectNodeTips: 'Please select a rejection node!',
      tips: 'Prompt',
      confirmMsg: 'Confirm',
      cancelMsg: 'Cancle',
      confirmSub: 'Confirm to Submit?',
      deleteTip: 'Confirm to Delete?',
      deleteSuc: 'Deleted Successfully',
      deleteFail: 'Failed to Delete',
      candelDel: 'Cancel Delete',
      saveSuccess: 'Save Successfully',
      saveFalse: 'Failed to Save',
      refuseSuccess: 'Refuse Successfully',
      refuseFalse: 'Failed to Refuse',
      submitSuccess: 'Successfully Submit',
      submitFalse: 'Failed to Submit',
      getSuccess: 'Successfully Get',
      getFail: 'Failed to Get',
      fuelInformation: 'Please fill in the fuel information',
      informationOilSampleAdd: 'Please add oil sampling information',
      passTips: 'Pass',
      refuseTips: 'Refuse',
      validFailTips: 'Operate failed,please contact the administrator',
      searchFail: 'Failed to Search',
      infoEdit: 'The basic information needs to be improved',
      confirmClose: 'Do you want to close this item?',
      closeSuc: 'Close Successfully',
      closeFail: 'Close Fail',
      confirmActivate: 'Do you want to activate this project?',
      activateSuc: 'Activate Successfully',
      activateFail: 'Activate Fail',
      cancelled: 'cancelled'
    }
  },
  marineChart: {
    chartSupplemenNum: 'ChartSupplemen Num',
    chartSupplemenContent: 'ChartSupplemen Content',
    dateEdition: 'Date Edition',
    remark: 'Remark',
    effectiveSupplement: 'Effective Supplement',
    shipSupplement: 'Ship Supplement',
    whetherBoard: 'isOnBoard',
    isActivateTips: 'Do you want to activate this message',
    activateTips: 'Tips',
    confirmTips: 'Confirm',
    cancelTips: 'Cancel',
    successTips: 'Activation successful',
    cancelledTips: 'Cancelled',
    chartManager: 'Marine',
    breadcrumb: 'Marine Books Monitor',
    title: 'Chart And Publication (ship)',
    companyTitle: 'Publication Allocation Standard',
    updateTitle: 'Update Latest Version',
    versionHistory: 'Update Record',
    vesselChart: 'Application Ship',
    button: {
      updateVersion: 'Update Latest Version',
      issueToVessel: 'Issue To Ship',
      updateSupplement: 'Update Supplement'
    },
    query: {
      allCompany: 'All Company',
      itemName: 'Book Code/Name',
      filterName: 'Filer',
      inputKeyWord: 'Please enter key words ',
      companyCode: 'Company Name',
      vesselCode: 'Ship Name',
      chartType: 'The type of chart'
    },
    table: {
      companyName: 'company Name',
      vesselName: 'Ship Name',
      vesselCode: 'Ship Name',
      chartType: 'Type of Chart',
      chartSubType: 'Chinese/English Version',
      chartNo: 'Book Code',
      chartName: 'Document Name',
      existVersion: 'Ship Version',
      newVersion: 'Latest Version',
      existQuantity: 'Ship Quanity',
      validSupplemen: 'Valid Supplement',
      valid: 'Effective',
      invalid: 'Invalid',
      chartRemark: 'Remark',
      inheritFlag: 'Inherit Company Template'
    },
    form: {
      validSupplement: 'Valid Supplement',
      chartSupplemenNum: 'Supplement Number',
      chartSupplemenContent: 'Supplement Content',
      dateEdition: 'Supplement Date',
      remark: 'Remark',
      vesselCode: 'Ship Name',
      chartType: 'The type of chart',
      chartSubType: 'Chinese/English Version',
      chartNo: 'Book Code',
      chartName: 'Document Name',
      newVersion: 'Latest Version',
      existVersion: 'Ship Version',
      existQuantity: 'Ship Quanity',
      validSupplemen: 'Valid Supplement',
      operationName: 'Operator',
      operationDate: 'Operation Date',
      lastOperationName: 'Last Operator',
      lastOperationDate: 'Last Operation Date',
      chartRemark: 'Remark',
      previousVersion: 'Previous Version',
      updateVersion: 'Update Latest Version',
      summary: 'Remark',
      updater: 'Operator',
      updateDate: 'Operation Date',
      inheritFlag: 'Inherit Company Template',
      fixedVesselType: 'Applicable Vessel Type',
      vesselType: 'Vessel Type'
    },
    prompt: {
      vesselTips: 'Please Ship',
      chartTypeTips: 'Please the type of chart',
      chartNameTips: 'Please enter document name ',
      existVersionTips: 'Please enter ship version',
      existQuantityTips: 'Please enter ship quantity',
      newVersionTips: 'Please enter latest version',
      selectRecordTips: 'Please select one record',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500',
      chartNoReTips: 'Repeated Book Coding',
      companyUpdateTips: 'Select the inherited company template to be updated by the company',
      issueToVesselTips: 'Issue to ship successfully',
      fixedVesselTypesTips: 'Please select vessel type'
    }
  },
  voyVessel: {
    index: {
      home: 'Marine',
      vessels: 'Voyage Execution',
      voy: 'Voyage',
      executing: 'Node Executing',
      nodeEnd: 'Node End',
      nodeNoEdit: 'The Node Cannot Be Edited',
      voyExecute: 'Voyage Execution',
      nodeTips: 'Digital ID in node (M / N / P) M: quantity approved / N: quantity to be approved / P: total quantity of all records in the node',
      cargo: 'Cargo Management',
      bunkerOperates: 'Bunker Management',
      bunkerOperate: 'Bunker',
      cargoOperate: 'Get loading and discharging port',
      chartUpdate: 'Chart and publication warning',
      addVoyPlan: 'Add Voyage Scheme',
      table: {
        port: 'Port',
        trainDate: 'Train Date',
        actualDate: 'Start Date',
        actualEndDate: 'End Date',
        inspectionDate: 'Delivery Date',
        purpose: 'Purpose',
        preparation: 'Preparation',
        inPort: 'Working On Port',
        voyMonitor: 'Cargo Monitoring'
      }
    }
  },
  voyTask: {
    voyLegInfo: 'Voyage Leg Info.',
    select: 'Select',
    index: {
      titleName: 'Voyage Scheme',
      revisedTitleName: 'Revised Voyage Scheme',
      basic: 'Basic Info.(Master)',
      ship: 'Ship Name',
      task: 'Voyage',
      historyVersion: 'History Version',
      startTime: 'ETD(LT)',
      timeZone: 'Time Zone',
      endTime: 'ETA(LT)',
      durationTime: 'Duration Days',
      departPortCode: 'Port of Departure ',
      arrivePortCode: 'Port of Destination',
      loadingPortCode: 'Loading Port',
      dischargePortCode: 'Discharging Port',
      middlePortCode: 'Intermediate Port',
      bunkerPortCode: 'Bunkering Port',
      abstract: 'Remark',
      cargoInfo: 'Cargo Info.(Master)',
      portInfo: 'Port Info.',
      addCargo: 'Add',
      riskAssess: 'Voyage Risk Assessment(Master)',
      addRisk: 'Add',
      masterRequire: 'Master’s Instruction',
      legInfo: 'Distance(2/O)',
      legInfoTips: 'The second officer is requested to call at all approach ports in the voyage plan in case the required leg information cannot be generated',
      addLeg: 'Add',
      loadLine: 'Load Line Used(2/O)',
      addLoadLine: 'Add',
      planSupply: 'Stowage Plan',
      stowagePlan: 'Stowage Plan(C/O)',
      addStowage: 'Add',
      supplyRequireDeck: 'Supply Requirement(C/O)',
      food: 'Fresh water and provisions',
      supplyRequireEngine: 'Supply Requirement(C/E)',
      fuel: 'Stores/Spare Parts/Bunker',
      revisedRemark: 'Revise Reason'
    },
    prompt: {
      vesselTips: 'Please Select Ship',
      voyageNoTips: 'Please Select Voyage',
      voyagePropTips: 'Please select the lease method',
      supplyRequireDeckTips: 'Please enter supply requirement(C/O)',
      supplyRequireEngineTips: 'Please enter supply requirement(C/E)',
      departPortCodeTips: 'Please select port of departure',
      voyPlanTips: 'Please fill in the basic information of the voyage and save it',
      voyLegSingleTips: 'Please select a segment information as the departure port of the new segment',
      addLegTips: 'The destination port of the selected segment is empty. Please complete the segment before adding a new segment',
      existVoyTips: 'There is an un executed voyage in the system. You cannot add a new voyage',
      existUnEndVoyTips: 'The last voyage has not been completed. Please finish the last voyage before performing this operation',
      getCargoInfoTips: 'The cargo port comes from the approved voyage plan. The current voyage plan has not been approved and cannot be obtained',
      revisedRemarkTips: 'Please fill in the revise reason',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500',
      dontDeleteLegATips: 'This segment is the port of departure and cannot be deleted',
      leaveLegTips: 'This segment has already left the port of departure. You can not delete it any more. You can only modify it',
      voyageNodeTips: 'Tip: Orange indicates that the node is in execution, green indicates that the node is finished, and gray indicates that the current node cannot be edited',
      voyageNodeCountTips: 'The digital ID of each node M / N / P: where m is the number of approved completed, n is the number of all the records that need to be approved, and P is the total number of all records in the node',
      voyageNoPlanTips: 'Prompt: there is no voyage plan in the system, please make voyage plan by captain',
      voyageNoStandardTips: 'The voyage number is identified by vyy01%%, in which YY indicates the year and 01 two digit serial number, where%% represents the mode of voyage leasing (such as TC time charter, TCT voyage time charter, VC voyage charter and r-repair voyage), please enter according to the rules',
      voyageNoReTips: 'This voyage number already exists in the system, please fill in again',
      doVoyagePlanTips: 'Please fill in the plan of voyage '
    },
    cargo: {
      titleName: 'Cargo Info.',
      table: {
        cargoName: 'Description of Goods',
        cargoTransportType: 'Nature of Cargo',
        cargoFlag: 'A Goods',
        cargoNum: 'Quantity/Weight',
        isolation: 'Segregation',
        cargoRemark: 'Remark'
      },
      form: {
        cargoName: 'Description of Goods',
        cargoTransportType: 'Nature of Cargo',
        cargoFlag: 'A Goods',
        cargoFlagY: 'Yes',
        cargoFlagN: 'No.',
        cargoNum: 'Quantity/Weight',
        isolation: 'Segregation',
        cargoRemark: 'Remark'
      },
      prompt: {
        cargoNameTips: 'Please Select Cargo',
        cargoTypeCodeTips: 'Please select nature of cargo',
        fieldLengthTips1: 'Length from 1 to 20',
        fieldLengthTips2: 'Length from 1 to 50',
        fieldLengthTips3: 'Length from 1 to 200',
        fieldLengthTips4: 'Length from 1 to 500'
      }
    },
    port: {
      table: {
        portFlag: 'Type',
        portOrAnchoName: 'Port/Berth',
        channelWatch: 'On Duty Channel',
        remark: 'Remark'
      }
    },
    leg: {
      titleName: 'Distance',
      table: {
        legCode: 'Voyage Leg Code(generated by the system)',
        legDepartPort: 'Port of Departure',
        legArrivePort: 'Port of Destination',
        legDistance: 'Distance',
        portPurpose: 'Purpose'
      },
      form: {
        legDepartPort: 'Port of Departure',
        legArrivePort: 'Port of Destination',
        legDistance: 'Distance',
        portPurpose: 'Purpose'
      },
      prompt: {
        arrivePortCodeTips: 'Please select port of departure',
        portPurposeCodeTips: 'Please select port of destination',
        portDistanceTips: 'Please Enter Distance'
      }
    },
    risk: {
      titleName: 'Voyage Risk Assessment',
      table: {
        riskRange: 'Risk Source',
        riskItem: 'Risk Effect',
        riskMeasure: 'Take Measures'
      },
      form: {
        riskRange: 'Risk Source',
        riskItem: 'Risk Effect',
        riskMeasure: 'Take Measures'
      },
      prompt: {
        riskRangeTips: 'Please select risk source',
        riskItemTips: 'Please select risk effect',
        riskMeasureTips: 'Please enter take measures',
        fieldLengthTips1: 'Length from 1 to 20',
        fieldLengthTips2: 'Length from 1 to 50',
        fieldLengthTips3: 'Length from 1 to 200',
        fieldLengthTips4: 'Length from 1 to 500'
      }
    },
    readPlan: {
      titleName: 'Review of cadres and crew',
      table: {
        objectName: 'Role/Person to be read',
        readName: 'Read Person',
        readTime: 'Read Date'
      }
    },
    stowageplan: {
      titleName: 'Cargo Stowage Plan',
      table: {
        cargoName: 'Description of Goods',
        portCode: 'Loading Port',
        seaDensity: 'Sea Water Density(g/cm3)',
        arriveDraft: 'Arr. Draft(m)',
        departDraft: 'Dep. Draft(m)',
        no1: 'No.1(MT)',
        no2: 'No.2(MT)',
        no3: 'No.3(MT)',
        no4: 'No.4(MT)',
        no5: 'No.5(MT)',
        no6: 'No.6(MT)',
        no7: 'No.7(MT)',
        no8: 'No.8(MT)',
        no9: 'No.9(MT)',
        deck: 'Deck(MT)',
        totalNum: 'Total Quantity(MT)'
      },
      form: {
        portCode: 'Loading Port',
        cargoName: 'Description of Goods',
        seaDensity: 'Sea Water Density(g/cm3)',
        arriveDraft: 'Arr. Draft(m)',
        departDraft: 'Dep. Draft(m)',
        Front: '/dF',
        in: '/dM',
        after: '/dA',
        no1: 'No.1(MT)',
        no2: 'No.2(MT)',
        no3: 'No.3(MT)',
        no4: 'No.4(MT)',
        no5: 'No.5(MT)',
        no6: 'No.6(MT)',
        no7: 'No.7(MT)',
        no8: 'No.8(MT)',
        no9: 'No.9(MT)',
        deck: 'Deck(MT)',
        totalNum: 'Total Quantity(MT)',
        planTotalNum: 'Plan Quantity(MT)'
      },
      prompt: {
        cargoNameTips: 'Please Select Cargo',
        portCodeTips: 'Please Select Port',
        fieldLengthTips1: 'Length from 1 to 20',
        fieldLengthTips2: 'Length from 1 to 50',
        fieldLengthTips3: 'Length from 1 to 200',
        fieldLengthTips4: 'Length from 1 to 500'
      }
    },
    loadline: {
      titleName: 'Load Line Used',
      table: {
        startPosition: 'From',
        endPosition: 'To',
        usedLoadline: 'Use Load Line'
      },
      form: {
        startPosition: 'From',
        endPosition: 'To',
        usedLoadline: 'Use Load Line'
      },
      prompt: {
        startPositionTips: 'Please enter from position',
        endPositionTips: 'Please enter to position',
        usedLoadlineTips: 'Please select use load line',
        fieldLengthTips1: 'Length from 1 to 20',
        fieldLengthTips2: 'Length from 1 to 50',
        fieldLengthTips3: 'Length from 1 to 200',
        fieldLengthTips4: 'Length from 1 to 500'
      }
    },
    VoyageTaskTracking: {
      previousVo: 'Back',
      nextVo: 'Next',
      title: 'Voyage History Query',
      qualityRecordName: 'Quality Record Name',
      qualityRecordCount: 'Quality Record Count',
      companyName: 'Company Name',
      vesselName: 'Ship Name',
      voyageNo: 'Voyage',
      departPort: 'Port of Departure',
      arrivePort: 'Port of Destination',
      startTime: 'Start Date',
      endTime: 'End Date',
      voyageDay: 'Duration Days',
      status: 'Status',
      operate: 'Operate'
    }
  },
  voyStart: {
    titleName: 'Before Sailing'
  },
  voyPlan: {
    titleName: 'Voyage Plan',
    shipName: 'Ship Name',
    voyTaskName: 'Voyage',
    departPortCode: 'Port of Departure ',
    arrivePortCode: 'Port of Destination'
  },
  voyIn: {
    titleName: 'At Sea'
  },
  voyEnd: {
    titleName: 'Voyage Summary',
    uploadTips1: 'Please upload the deck department log',
    uploadTips2: 'Please upload the engine log'
  },
  voyAfter: {
    titleName: 'After Arrival'
  },
  editGoods: {
    mainTitleName: 'Marine',
    titleName: 'Cargo Info.',
    cargoStep1: 'Preparation (before loading/unloading)',
    cargoStep2: 'Operation in Port (loading/unloading process)',
    cargoStep3: 'Cargo Monitoring (after loading/unloading)',
    basicInfo: 'Basic Info.',
    shipName: 'Ship Name',
    voyTaskName: 'Voyage',
    cargoInfo: 'Cargo Info.',
    port: 'Port',
    aim: 'Purpose',
    goodsPhotos: 'Photos of cargo hold condition',
    prompt: {
      confirmCompleted: 'Please confirm that all information of the port is completed? After submission, the information in this node cannot be modified. If you want to modify it, please notify the captain to reactivate the process status.',
      selectCargoInfo: 'Please select the goods to be loaded and unloaded at this port',
      selectSaveCargoInfo: 'Please select the goods loaded and unloaded at this port and save them！',
      notSaveCargoInfo: 'Note: Please select the goods loaded and unloaded at this port and save them. After saving, the system documents to be filled in will be generated'
    }
  },
  bunkerTransfer: {
    mainTitleName: 'Marine',
    titleName: 'Bunker Transfer',
    bunkerStep1: 'Bunker Transfer-plan',
    bunkerStep2: 'Bunker Transfer-train',
    bunkerStep3: 'Risk Assessment',
    bunkerStep4: 'Bunker Transfer-actual Execute',
    bunkerStep5: 'Bunker transfer-oil sample send to corp',
    bunkerStep6: 'Bunker Transfer-lab. Report',
    basicInfo: 'Basic Info.',
    supplierInfo: 'Supply Info.',
    supplierName: 'Supply',
    oilName: 'Oil Type',
    transferCount: 'Add Quantity（MT）',
    remark: 'Remark',
    vesselName: 'Ship Name',
    voyTaskName: 'Voyage',
    port: 'Port',
    country: 'Country',
    planNo: 'Plan No.',
    planStartDate: 'Plan Start Date(LT)',
    planEndDate: 'Plan End Date(LT)',
    trainDate: 'Train Date(LT)',
    actualTrainDate: 'Actual Train Date(LT)',
    timeZone: 'Time Zone',
    planNoMessage: 'Please enter plan no.',
    portMessage: 'Please Select Port',
    timeZoneMessage: 'Please select time zone',
    planStartDateMessage: 'Please select plan start date',
    planEndDateMessage: 'Please select plan end date',
    trainDateMessage: 'Please select train date',
    actualTrainDateMessage: 'Please select actual date',
    trainTitle: 'Train',
    trainExplain: 'Within 48 hours before planned refueling, the chief engineer shall train all refueling personnel on their responsibilities and operation plan in this procedure. The name, position and specific time of the trainees shall be recorded in the engine logbook and deck logbook',
    expectRiskDate: 'Risk Date(LT)',
    expectRiskDateMessage: 'Please select risk date(LT)',
    riskAssess: 'Risk Assessment',
    actualStartDate: 'Actual Start Date(LT)',
    actualStartDateMessage: 'Please select actual start date(LT)',
    actualEndDate: 'Actual End Date(LT)',
    actualEndDateMessage: 'Please select actual end date(LT)',
    OilSampleDeliveryDate: 'Delivery Date(LT)',
    OilSampleDeliveryDateMessage: 'Please select delivery date(LT)',
    firstBunkerMeeting: 'Meeting Before Refueling',
    firstBunkerMeetingExplain: 'Before the start of refueling operation, all refueling personnel, including those on shore or on the tanker, shall hold a meeting. If the master thinks that it is unsafe for the personnel on shore or on the tanker to board the ship, he may not participate. The participants will focus on how to inform the personnel of the tanker or the onshore gas station about changing the oil tank or slowing down due to full tank or full tank, and determine the emergency pump shutdown procedure and contact method. The above contents shall be recorded in the logbook',
    firstBunkerMeetingExplainTwo: 'Every time the fuel is filled, the oil sample must be sent to the designated laboratory for testing. Do not use the fuel until the test report is received. After receiving the report, you need to follow the recommendations on fuel storage, lightering and distribution in the report.',
    firstBunkerMeetingExplainThree: 'If the ship fails to receive the test report of oil products in time and has to use fuel of unknown quality, it is necessary to inform the company maintenance department in advance, and carry out risk assessment and preventive measures according to stability, compatibility, residual catalyst and other aspects.',
    testReportTitle: 'Oil sample test report',
    supplierMessage: 'Please add at least one supplier',
    oilInfoSourceNullTips: 'Supplier list supplier / oil product name / (transfer volume > 0) shall be filled in completely',
    prompt: {
      confirmSub: 'Are you sure you want to complete the oil transfer operation',
      completedSuc: 'Complete',
      completedFail: 'Operation Failed'
    },
    testReport: {
      reportTitle: 'Oil sample test report',
      testOrg: 'Lab. Organization',
      testOrgInput: 'Please enter lab. organization',
      sampleNo: 'Lead Seal Number',
      sampleNoSelect: 'Please enter lead seal number',
      supplierName: 'Supply',
      bunkerCode: 'Oil Name',
      shoreRemark: 'Corp Opinion',
      shoreRemarkInput: 'Please enter shore-based opinion',
      vesselRemark: 'Ship Opinion',
      vesselRemarkInput: 'Please Ship Opinion',
      status: 'Status'
    },
    bunkerSample: {
      takeBunkerSample: 'Take Oil Sample',
      bunkerVendor: 'Supply',
      sampleNo: 'Lead Seal Number',
      samplePurposeCode: 'Purpose',
      samplePurposeCodeSelect: 'Please Select Purpose',
      sampleRemark: 'Remark',
      supplierName: 'Please Select Supply',
      sampleNoInput: 'Please enter lead seal number'
    },
    bunkerBank: {
      bankerRecord: 'Oil Tank Record',
      index: 'No.',
      tankNo: 'Oil Tank',
      tankNoSelect: 'Please enter oil tank',
      bunkerType: 'Oil Name',
      bunkerTypeSelect: 'Please select oil name',
      beforeQuantity: 'Quantity Before Transfer(MT)',
      beforeQuantityInput: 'Please enter quantity before transfer',
      beforeSulfur: 'Sulfur Before Transfer(%)',
      beforeSulfurInput: 'Please enter sulfur before transfer',
      afterQuantity: 'Quantity After Transfer(MT)',
      afterQuantityInput: 'Please enter quantity after transfer',
      afterSulfur: 'Sulfur After Transfer(%)',
      afterSulfurInput: 'Please enter sulfur after transfer',
      remark: 'Remark'
    }
  },
  editPilot: {
    titleName: 'Pilot Info.',
    basicInfo: 'Basic Info.',
    pilotName: 'Pilot Name',
    portFlag: 'Type',
    portName: 'Port',
    timeZone: 'Time Zone',
    onDate: 'POB(LT)',
    leaveDate: 'DOP(LT)',
    masterName: 'Master',
    onPosition: 'Embarkation',
    leavePosition: 'Disembarkation',
    serviceQuality: 'Quality of Service',
    exchangeTable: 'Master/Pilot Info. Exchange List',
    prompt: {
      pilotNameTips: 'Please enter pilot name',
      onDateTips: 'Please select on ship date(LT)',
      leaveDateTips: 'Please select leave ship date(LT)',
      onPositionTips: 'Please enter Embarkation',
      leavePositionTips: 'Please enter Disembarkation',
      serviceQualityTips: 'Please enter quality of service',
      timeZoneTips: 'Please enter time zone',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500'
    }
  },
  MarineNarrow: {
    titleName: 'Narrow Info.',
    inspection: 'Narrow Info.',
    shipName: 'Ship Name',
    voyTaskName: 'Voyage',
    seaArea: 'Sea Area',
    SpecialpointName: 'Narrow Name',
    remarks: 'Remark',
    checkDate: 'Check Date(LT)',
    checkTimeZone: 'Time Zone',
    startDate: 'Start Date',
    startTimeZone: 'Start Time Zone',
    endDate: 'End Date',
    endTimeZone: 'End Time Zone',
    prompt: {
      specialCodeTips: 'Please select narrow name',
      checkDateTips: 'Please enter check date',
      checkTimeZoneTips: 'Please enter time zone',
      startDateTips: 'Please select start date',
      startTimeZoneTips: 'Please select start time zone',
      endDateTips: 'Please select end date',
      endTimeZoneTips: 'Please select end time zone',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500'
    }
  },
  MarineFrog: {
    frogReptTitle: 'Report for Sailing in Restricted Visibility',
    frogCheckTitle: 'Check List for Sailing in Restricted Visibility',
    sysNo: 'Frog No(system)',
    reportType: 'Type',
    shipName: 'Ship Name',
    shipCode: 'Voyage',
    dataTime: 'Report Date(LT)',
    code: 'Report No.',
    visibility: 'Visibility(Level)',
    seaArea: 'Sea Area',
    course: 'Course(°)',
    Speed: 'Speed(Kt)',
    shipPosition: 'Position',
    lastShipPosition: 'Ship Position(ending)',
    driver: 'OOW',
    seaman: 'AB On Watch',
    windDirection: 'Wind Direction',
    windPower: 'Wind Force(BF)',
    WaveHeight: 'Height of Wave(m)',
    Yonggao: 'Height of Swell(m)',
    weatherCondition: 'Weather',
    DryBall: 'Dry Temp.(℃)',
    bulb: 'Wet Temp(℃)',
    density: 'Traffic Density',
    Theseamusttake: 'Measures should be taken when visibility is 3-5 miles',
    outlook: 'Kept a sharp look-out',
    SafeSpeed: 'Proceeded at a safe speed',
    radar: 'Kept a continuous observation and plotting by radar',
    drives: 'Opened windows and doors on bridge',
    VHF: 'Monitored On VHF',
    shipQuiet: 'Kept whole ship silence',
    fogSignal: 'Sounded Fog Signal',
    navigation: 'Switched on nav. light',
    captain: 'Reported to Master',
    byHand: 'Changed to hand steering',
    Inform: 'Gave a notice to E/R',
    ConsiderIncreasing: 'Additional Measures should be considered to adopt when visibility is less than 3 miles',
    TwoRadars: 'Kept a continuous observation/plotting by 2 radars',
    warningVia: 'Broadcasted fog warning by VHF',
    driving: 'Master took over command on bridge',
    vehicle: 'Standby engine during sailing',
    theHead: 'Posted lookout on the forecastle',
    andDetention: 'Stopped engine and heaved to the ship',
    anchor: 'Got ready for anchoring',
    NavigationEquipment: 'Nav. Equipment、instrument and Comm Equipment',
    Normal: 'Normal',
    Deficiency: 'Abnormal',
    security: 'To ensure navigation safety in restricted visibility, master has right to make a decision on anchoring, heaving to the ship under circumstance permit in the case of sailing in bad visibility, area with crowded fishing vessels, taking avoidance measure difficultly, complex channel and he is unsure about navigation safety. Do not sail without assurance.',
    remarks: 'Remark',
    checkDate: 'Check Date(LT)',
    checkTimeZone: 'Time Zone',
    startDate: 'Start Date',
    startTimeZone: 'Start Time Zone',
    endDate: 'End Date',
    endTimeZone: 'End Time Zone',
    minVisibility: 'Visibility (grade) (minimum)',
    totalTime: 'Total Fog Time (hours)',
    takeMeasures: 'Take Steps',
    prompt: {
      sysReportNoTips: 'Please select frog no.(system)',
      reportDateTips: 'Please select report date',
      reportNoTips: 'Please enter report no',
      frogVisibilityTips: 'Please Select Visibility',
      seaAreaCodeTips: 'Please enter sea area',
      sailingCourseTips: 'Please enter Course',
      sailingSpeedTips: 'Please enter Speed',
      vesselPositionTips: 'Please enter Position',
      checkDateTips: 'Please select check date(LT)',
      checkTimeZoneTips: 'Please select time zone',
      startDateTips: 'Please select start date',
      startTimeZoneTips: 'Please select start time zone',
      endDateTips: 'Please select end date',
      endTimeZoneTips: 'Please select end time zone',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500'
    }
  },
  MarineSummary: {
    infoSummary: 'Summary report of new route or new port',
    Voyagestarttime: 'Actual Start Date',
    Voyageendtime: 'Actual End Date',
    Duration: 'Duration Days',
    vesselType: 'Ship Category',
    status: 'Status',
    Addedby: 'Operator',
    AddDate: 'Operation Date',
    adds: 'Add',
    information: 'Voyage Basic Info.(from voyage scheme)',
    route: 'Route(from voyage scheme)',
    objective: 'Purpose of Call(Loading/unloading/bunkering/others)',
    Summary: 'Summary Route ',
    conduction: 'Weather Routing Service',
    Yes: 'Yes',
    No: 'No.',
    Loadline: 'Load Lines(from voyage scheme)',
    event: 'Incident',
    describe: 'Description',
    position: 'Location (or area)',
    measures: 'Precaution adopted and result',
    Summaryoftheports: 'Summary of the route',
    Port: 'Name of Port/Anchorage',
    remark: 'Remark',
    remarkMax: 'Remark',
    portName: 'Port',
    portNameSelect: 'Please Select Port',
    anchorName: 'Anchorage',
    anchorNameInput: 'Please Enter Anchorage',
    channel: 'VHF channel for watch',
    channelInput: 'Please enter VHF channel for watch',
    pilot: 'Pilot(from duration of voyage add)',
    name: 'Pilot Name',
    boardFront: 'Embarkation',
    Lat: 'Lat',
    Long: 'Long',
    service: 'Quality of Service',
    describes: 'Others',
    SegmentSituation: 'Channel',
    length: 'Distance, width  & depth maintained',
    Shallow: 'Position shallowest point and depth',
    tide: 'Tide And Stream',
    otherTide: 'Others',
    Berthing: 'Mooring & Unmooring/Anchoring',
    Numberoftugs: 'Tugs and Power',
    BerthingPosition: 'Berth location and depth',
    Cargo: 'Cargo Operation',
    Useofcargocrane: 'Loading/Unloading Gears Used',
    Cargohandlingteam: 'Stevedores shift and loading/unloading rate',
    Stevedoreswork: 'Service quality of stevedores',
    Assessment: 'Draft survey and water density',
    Entry: 'Formalities',
    equirements: 'Pre-arrival Report',
    ready: 'Documents Prepared',
    Otherrequiremen: 'Others',
    situation: 'Security',
    Smuggling: 'Stowaway, Public Security',
    Security: 'PFSL',
    Voyagesummaryreport: 'Summary report of new route or new port',
    cargoInfo: 'Cargo Info.(from voyage scheme)',
    badWeather: 'Bad Weather, Sea Conditions',
    seaSafety: 'Maritime Security',
    denseTrafficZone: 'Navigation Intensive Area',
    specialArea: 'Special Navigation Area',
    others: 'Other',
    voyPortInfo: 'Voyage Port Info.',
    port: 'Port',
    anchor: 'Anchor',
    prompt: {
      startTimeTips: 'Please select actual start date',
      endTimeTips: 'Please select actual end date',
      timeZoneTips: 'Please select time zone',
      pleaseFirstSave: 'Please Save First',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500'
    }
  },
  uck: {
    titleName: 'Ukc Calculation Sheet',
    parameterinformation: 'Parameter Info.',
    essentialinformation: 'Basic Info.',
    position: 'Location',
    Speed: 'Speed(Kt)',
    waterArea: 'Water Area',
    distance: 'The length of waiting tide(NM)',
    weaveHeight: 'Height of Wave(m)',
    Draft: 'Draft',
    Front: 'Aft',
    in: 'Mid',
    after: 'Fwd',
    visibility: 'Area',
    seaState: 'UKC Name',
    heavyOil: 'ETA(LT)',
    arriveDate: 'Actual Arrival Time',
    Standard: 'Displacement Under S.G.1.025(from Stability calculation)',
    appoint: 'Water Density',
    centimeter: 'T.P.C.under current draft(from Stability calculation)',
    Variation: 'Water Allowance((Displacement under S.G.1.025*(1.025-Water Density)/1.025)/T.P.C.under current draft/100)',
    recommend: 'Max Transit Speed(Knots)',
    Shipwidth: 'Ship Breath',
    angle: 'Angle of Heel (°)',
    coefficient: 'Block Coefficient(from Stability calculation)',
    Subsidence: 'Squat',
    Shallowwaters: 'Confined Water',
    Deepwater: 'Open Water',
    Shallowest: 'Minimum Controlling Depth at position',
    ENC: 'ENC CATZOC Allowance',
    weather: 'Weather Allowances(+/-)meters(30% wave height)',
    Surpluswater: 'Required Net UKC(documents require)',
    result: 'Result',
    specified: 'Draft under specified water density(Draft+Water Allowance)',
    Static: 'Static Draft(Draft under specified water density)',
    Correction: 'List Correction(+)( Static Draft*COS(Angle of Heel (°)*3.1415926/180)+1/2*Breath*SIN(Angle of Heel (°)*3.1415926/180)-Static Draft',
    Effectve: 'Effecitve Draft( Static Draft+Squat+List Correction(+):)',
    DYnamic: 'Dynamic Depth(B)( Minimum Controlling Depth at position-ENC CATZOC Allowance-Weather Allowances(+/-)meters-Required Net UKC)',
    Requiredheight: 'Required height of tide(Dynamic Depth(B)-Effective Draft)',
    requiredHeightTips: 'If the "Required Height of Tide" is less than or equal to "0", calculation of tide is not requested.',
    TidalTnformation: 'Tide Info.',
    heightTide: 'Required Height of Tide Commence',
    end: 'Required Height of Tide End',
    Duration: 'Duration of Required Tide',
    Safe: 'Duration of pass safety',
    add: 'Add',
    tideTable: 'Tide Table',
    tide: 'Tide',
    Time: 'Time',
    Height: 'Height ',
    Selectdate: 'Please Select Date',
    ukcName: 'UKC Name',
    seaAreaCode: 'Sea Area',
    ukcStandard: 'UKC Standard',
    vesselPosition: 'Ship Position',
    ukcFlag: 'Ukc Type',
    calResult: 'Result',
    fitFlag: 'Does it meet the requirements',
    ukcStatus: 'Status',
    waterFlag: 'Waters',
    noPassSaveFlag: 'No Safe Passage',
    passSafeFlag: 'Safe Passage',
    timeZone: 'Time Zone',
    prompt: {
      placeNameTips: 'Please Enter Location',
      seaAreaCodeTips: 'Please enter sea area',
      arriveDateTips: 'Please Select ETA',
      waveHeightTips: 'Please enter height of wave',
      sqFlagTips: 'Please select water area',
      timeZoneTips: 'Please select time zone',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500'
    }
  },
  MarineTyphoon: {
    titleName: 'Report for Precaution Against Typhoon',
    typhoonInfo: 'Heavy Weather Info.',
    typhoonSysNo: 'Typhoon No(System)',
    typhoonSysType: 'Type',
    typhoonNo: 'Typhoon No.',
    typhoonName: 'Typhoon Name',
    seaAreaCode: 'Sea Area',
    shiplongitude: 'Ship Position(longitude)',
    shiplatitude: 'Ship Position(latitude)',
    Selectdate: 'Please Select Date',
    shipName: 'Ship Name',
    shipCode: 'Voyage',
    dataTime: 'Report Date(LT)',
    timeZone: 'Time Zone',
    code: 'Report No.',
    departure: 'Port of Departure',
    destination: 'Port of Destination',
    Shipposition: 'Position',
    endShipPosition: 'Position When End',
    longitude: 'Longitude',
    latitude: 'Latitude',
    goods: 'Cargo',
    draft: 'Draft(m)',
    Front: 'Fwd',
    in: 'Mid',
    after: 'Aft',
    weather: 'Weather',
    windDirection: 'Wind Direction',
    windPower: 'Wind Force(BF)',
    course: 'Course(°)',
    pressure: 'Pressure(hpa)',
    visibility: 'Visibility(Level)',
    seaState: 'Seas(Level)',
    Speed: 'Speed(Kt)',
    temperature: 'Temperature(℃)',
    heavyOil: 'FO(MT)',
    lightOil: 'DO(MT)',
    freshwater: 'FW(MT)',
    BallastWater: 'BW(MT)',
    engineSpeed: 'RPM',
    position: 'Typhoon Position',
    CentralPressure: 'Central Pressure(hpa)',
    MovingDirection: 'Moving Direction',
    movingSpeed: 'Moving Speed(Kt)',
    ShipCenter: 'Distance to Center(NM)',
    cause: 'To Ship',
    affectingships: 'Weather System',
    Monsoon: 'Monsoon',
    Sources: 'Source of Weather Info.',
    Fax: 'Fax',
    NAVTEX: 'NAVTEX',
    C: 'Station C',
    AC: 'Air Conduction',
    Others: 'Others',
    informationTime: 'Date/Time of Recently Weather Info.',
    Antagonizing: 'Measures for Preventing and Antagonizing Typhoon',
    conference: 'Anti-Typhoon Meeting',
    Yes: 'Yes',
    No: 'No.',
    equipment: 'Condition of Anti-Typhoon equipments',
    Normal: 'Normal',
    Deficiency: 'Deficiency',
    info: 'M/E, A/E, Steering, Windlass, Boiler',
    sail: 'Under Way',
    SD: 'SD ',
    SA: 'Accelerate',
    Heaveto: 'Heave to',
    Change: 'A/C',
    measures: 'Whether report to Ocean route/Charterers /Company',
    shelter: 'Anchoring: Sheltered Anchorage',
    Good: 'Good ',
    Poor: 'Poor ',
    texture: 'Seabed',
    Goods: 'Good ',
    Moderate: 'Moderate ',
    Poors: 'Poor ',
    anchor: 'Method',
    Onepoint: 'One point',
    OpenMooring: 'Open Mooring',
    SingleAnchoring: 'Single Anchoring(Port Anchor or Starboard)',
    PortAnchor: 'Port Anchor',
    Starboard: 'Starboard ',
    Kts: 'Shackle ',
    objectMark: 'Object for fixing position',
    Prominent: 'Prominent ',
    nearestDistance: 'The Nearest Distance',
    NM: 'NM',
    flow: 'Current',
    Fast: 'Fast ',
    Speedp: 'Speed',
    urgent: 'Mooring',
    Authority: 'Liaise with port Authority',
    SBE: 'SBE ',
    mooringLines: 'Add Mooring Lines',
    Anchorage: 'Shift to Anchorage',
    Assistance: 'Tug Assistance',
    recommend: 'Recommendation from Ocean route',
    situation: 'Conditions for ship and cargo',
    checkTitleName: 'Heavy Weather Checklist',
    NA: 'N/A',
    checkDate: 'Check Date(LT)',
    checkTimeZone: 'Time Zone',
    losedTime: 'Lost Time (hours)',
    deviateMile: 'Mileage Around (NM)',
    consumedOil: 'Additional Fuel Consumption(MT)',
    sufferLose: 'Suffer Losses',
    personInjured: 'Casualties',
    personName: 'Name',
    injuredRemark: 'Casualty Description',
    polluteSituation: 'Pollution Situation',
    deviceDamage: 'Equipment Damage(name)',
    otherDamage: 'Others (specify)',
    startDate: 'Start Date',
    startTimeZone: 'Start Time Zone',
    endDate: 'End Date',
    endTimeZone: 'End Time Zone',
    totalTime: 'Total passing time of typhoon (hours)',
    takeMeasures: 'Take Steps',
    deviateMeasure: 'Detour Measures',
    stopMeasure: 'Drift / Delay Measures',
    cargoCondition: 'Loading and Unloading',
    vesselStatus: 'Dynamic',
    ladenType: 'Loading Condition',
    centralWindSpeed: 'Maximum wind near the center(m/s)',
    relativePosition: 'In the quadrant of Typhoon',
    prompt: {
      reportNoInputTips: 'Please enter report no. like 01、02、03......',
      courseInputTips: 'Please enter course from 000 to 359',
      seaAreaCodeTips: 'Please enter sea area',
      reportDateTips: 'Please select report date',
      checkDateTips: 'Please select check date(LT)',
      timeZoneTips: 'Please select time zone',
      reportNoTips: 'Please enter report no',
      vesselPositionTips: 'Please Enter Position',
      sailingCourseTips: 'Please Enter Course',
      sailingSpeedTips: 'Please Enter Speed',
      windCourseTips: 'Please select wind course',
      windSpeedTips: 'Please select wind speed',
      vesselStatusTips: 'Please Select Dynamic',
      frogVisibilityTips: 'Please Select Visibility',
      deficiencyTips: 'If there is a defect, please enter',
      othersTips: 'Supplemental Instruction',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500',
      sysReportNoTips: 'Please select typhoon no(System)',
      specialCodeTips: 'Please enter the typhoon number or name',
      endVesselPositionTips: 'Please enter end vessel position/anchor',
      deviateMeasureTips: 'Try to pass the tail of typhoon or grab the wind head of typhoon; keep the minimum distance from the center of typhoon. For example, the minimum distance between the tail of typhoon and the center of typhoon should be more than 300 nautical miles',
      stopMeasureTips: 'It should be noted that the way of drifting or staying should be noted, and the latitude and longitude should be noted to keep the closest distance from the typhoon center. For example, it floats at 2538N/12035E and keeps a minimum distance of more than 300 nautical miles from the typhoon center.',
      inputPersonInjuryTips: 'Please fill in the casualty information',
      startDateTips: 'Please select start date',
      startTimeZoneTips: 'Please select start time zone',
      endDateTips: 'Please select end date',
      endTimeZoneTips: 'Please select end time zone'
    }
  },
  Voyagetracking: {
    mngTitle: 'Marine',
    pageTitle: 'Assessment Report For New Route/Port',
    companyCode: 'Company Name',
    vesselCode: 'Ship Name',
    voyageNo: 'Voyage',
    Port: 'Port',
    Assessor: 'Evaluator',
    Evaluationdate: 'Date',
    Newrouteassessment: 'New Route Assessment',
    Newportassessment: 'New Port Assessment',
    conclusion: 'Conclusion',
    state: 'Status',
    Expectedarrivaldate: 'ETA',
    since: 'From',
    to: 'To',
    operationName: 'Operator',
    operationDate: 'Operation Date',
    yesNo: 'Is Referenced',
    associatedVoyage: 'Related Voyage',
    prompt: {
      vesselTips: 'Pleace Select Ship',
      voyageNoTips: 'Please Enter Voyage',
      portTips: 'Please Select Port',
      assessPersonTips: 'Please Enter Evaluator',
      assessDateTips: 'Please Enter Date',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500',
      fieldLengthTips5: 'Length from 1 to 2000'
    }
  },
  MarinePirate: {
    titleName: 'Through the pirate zone',
    pirateName: 'Pirate Zone',
    securityName: 'Armed Security',
    navalName: 'Naval Escort',
    seaArea: 'Sea Area',
    reportDate: 'Report Date',
    timeZone: 'Time Zone',
    startDate: 'Start Date',
    startTimeZone: 'Start Time Zone',
    endDate: 'End Date',
    endTimeZone: 'End Time Zone',
    attackPirate: 'Pirate Attack',
    securityFlag: 'Hire Armed Security',
    onDate: 'Date of Embarkation',
    onTimeZone: 'Boarding Time Zone',
    leaveDate: 'Sign-off Date',
    leaveTimeZone: 'Disembarkation Time Zone',
    onPosition: 'Boarding Position',
    leavePosition: 'Disembarkation Position',
    navalFlag: 'Arrange Naval Escort',
    navalStartDate: 'Convoy Start Date',
    navalStartTimeZone: 'Time Zone',
    navalEndDate: 'Escort End Date',
    navalEndTimeZone: 'Time Zone',
    navalStartPosition: 'Convoy Start Position',
    navalEndPosition: 'Escort End Position',
    pirateRemark: 'Remark',
    Yes: 'Yes',
    No: 'No.',
    prompt: {
      seaAreaTips: 'Please select sea area',
      reportDateTips: 'Please enter report date',
      timeZoneTips: 'Please enter report time zone',
      startDateTips: 'Please select start date',
      startTimeZoneTips: 'Please select start time zone',
      endDateTips: 'Please select end date',
      endTimeZoneTips: 'Please select end time zone',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500'
    }
  },
  MarineGoodHope: {
    titleName: 'Through the waters of Cape of good hope',
    ladenFlag: 'Load',
    isLaden: 'Heavy Ballast',
    draft: 'Draft',
    draftF: 'dF',
    draftA: 'dA',
    reportDate: 'Report Date(LT)',
    timeZone: 'Time Zone',
    badWeatherFlag: 'Encounter bad sea conditions',
    happenDate: 'Date of Occurrence',
    windPower: 'Wind Power (grade)',
    waveHeight: 'Wave Height',
    swellHeight: 'Swell(grade)',
    takeMeasure: 'Take Steps',
    remark: 'Remark',
    Yes: 'Yes',
    No: 'No.',
    draftTableF: 'Draft Front',
    draftTableA: 'Draft After',
    prompt: {
      ladenFlagTips: 'Please Select Load',
      draftTips: 'Please Enter Draft',
      reportDateTips: 'Please select report date(LT)',
      timeZoneTips: 'Please select report time zone',
      fieldLengthTips1: 'Length from 1 to 20',
      fieldLengthTips2: 'Length from 1 to 50',
      fieldLengthTips3: 'Length from 1 to 200',
      fieldLengthTips4: 'Length from 1 to 500'
    }
  },
  highRisk: {
    index: {
      home: 'Marine',
      title: 'High Risk Country/Port',
      queryName: 'Filter',
      querycountry: 'Country',
      queryPort: 'Port',
      disabledBtn: 'Disable',
      disableMsg: 'Do you want to disable the record',
      disableSuccessMsg: 'Disable Success',
      cancelDisableMsg: 'Cancel Disable',
      table: {
        areaType: 'Area Type',
        country: 'Country',
        port: 'Port',
        riskDescribe: 'Risk Describe',
        riskMeasure: 'Preventive measures and suggestions',
        effective: 'Effective Date',
        dateCreated: 'Create Date',
        dateUpdated: 'Update Date',
        expity: 'Expity Date',
        areaTypeC: 'Country',
        areaTypeP: 'Port'
      }
    },
    editHighRisk: {
      title: 'High Risk Country/Port',
      baseTitle: 'Base Info.',
      form: {
        fileName: 'Attachment upload',
        voyageNo: 'Voyage No',
        shipName: 'Ship Name',
        reportTitle: 'Ship Voyage Port Water Depth Data Report',
        riskType: 'Risk Type',
        baseTitle: 'Base Info.',
        areaType: 'Area Type',
        country: 'Country',
        port: 'Port',
        countryPort: 'Country/Port',
        riskDescribe: 'Risk Describe',
        riskMeasure: 'Preventive measures and suggestions',
        effective: 'Effective Date',
        expity: 'Expity Date',
        validFlag: 'Status'
      },
      selectMessage: {
        country: 'Country',
        port: 'Port'
      },
      formRules: {
        areaType: 'Area type cannot be empty',
        countryNull: 'When the region type is country, the country cannot be empty',
        country: 'The country already exists',
        countryPort: 'Country/Port cannot be empty',
        portNull: 'When the area type is port, the port cannot be empty',
        port: 'The port already exists',
        riskDescribe: 'Risk description cannot be empty',
        riskMeasure: 'Preventive measures and suggestions cannot be empty',
        effective: 'Effective date cannot be blank',
        riskTypeTips: 'Risk type cannot be empty',
        saveTips: 'Country or port already exists'
      }
    }
  },
  voyPortStatistics: {
    home: 'Marine',
    title: 'Ports of Call List',
    filterName: 'Filter',
    queryVessel: 'Ship',
    queryPort: 'Port',
    queryDate: 'Start and end date',
    exportBtn: 'Export',
    noData: 'No Data Available',
    table: {
      vesselName: 'Ship',
      voyageNo: 'Voyage No.',
      port: 'Port',
      country: 'Country',
      arrivePortDate: 'Arrival Date',
      arriveTimeZone: 'Arrival Time Zone',
      leavePortDate: 'Departure Date',
      leavePortTime: 'Departure Time Zone',
      arrivePortPurpose: 'Destination',
      remark: 'Remark'
    }
  },
  voyPirateStatistics: {
    home: 'Marine',
    title: 'Pass HRA List',
    filterName: 'Filter',
    queryVessel: 'Ship',
    queryArea: 'Sea Area',
    queryDate: 'Start and end date',
    exportDetailBtn: 'Export Detail',
    exportShipBtn: 'Export',
    table: {
      vesselName: 'Ship Name',
      pirateCode: 'Sea Area',
      startDate: 'Start Date',
      endDate: 'End Date',
      security: 'Armed Security',
      naval: 'Naval Escort',
      securityFlag: 'Employment Or Not',
      onPosition: 'Boarding Position',
      onDate: 'Boarding Time',
      leavePosition: 'Disembarkation Position',
      leaveDate: 'Disembarkation Time',
      navalFlag: 'Join Or Not',
      navalStartPosition: 'Convoy Start Position',
      navalStartDate: 'Convoy Start Time',
      navalEndPosition: 'Escort End Position',
      navalEndDate: 'Escort End Time'
    }
  },
  voyGoodHopeStatistics: {
    home: 'Marine',
    title: 'Pass Cape of Good Hope List',
    filterName: 'Filter',
    queryVessel: 'Ship',
    queryDate: 'Start and end date',
    exportBtn: 'Export',
    table: {
      vesselName: 'Ship Name',
      voyageNumber: 'Voyage No.',
      reportDate: 'Report Date(LTs)',
      load: 'Load',
      df: 'Draft Front',
      da: 'Draft After',
      badWeatherFlag: 'Is there any bad weather',
      windSpeed: 'Wind Power (grade)',
      waveLevel: 'Wave Height (grade)',
      swellLevel: 'Swell (grade)',
      takeMeasure: 'Take Steps',
      badWeatherFlagYes: 'Yes',
      badWeatherFlagNo: 'No.'
    }
  },
  voyNarrowStatistics: {
    home: 'Marine',
    title: 'Pass Narrow Channel List',
    filterName: 'Filter',
    queryVessel: 'Ship',
    queryNarrow: 'Narrow Channel',
    queryDate: 'Start and end date',
    exportBtn: 'Export',
    table: {
      vesselName: 'Ship Name',
      voyageNumber: 'Voyage No.',
      df: 'Draft Front',
      da: 'Draft After',
      narrowName: 'Narrow Channel Name',
      startDate: 'Start Date',
      startTimeZone: 'Start Time Zone',
      endDate: 'End Date',
      endTimeZone: 'End Time Zone'
    }
  },
  voyFrogStatistics: {
    home: 'Marine',
    title: 'List of Sailing in Restricted Visibility',
    filterName: 'Filter',
    queryVessel: 'Ship',
    queryDate: 'Start and end date',
    exportBtn: 'Export',
    table: {
      vesselName: 'Ship Name',
      voyageNumber: 'voyage No.',
      ladenType: 'Loading Condition',
      seaAreaCode: 'Sea Area',
      visibility: 'Visibility',
      fogNavalStartDate: 'Fog Start Date',
      fogNavalEndDate: 'Fog End Date',
      startTimeZone: 'Start Time Zone',
      endTimeZone: 'End Time Zone',
      timeZone: 'Time Zone',
      fogNavalAllTime: 'Total Fog Time',
      takeMeasure: 'Take Steps',
      remark: 'Remark'
    }
  },
  voyTyphoonTrackStatistics: {
    home: 'Marine',
    title: 'Typhoon Tracking List',
    filterName: 'Filter',
    queryVessel: 'Ship',
    tackValue: 'Typhoon No./name',
    queryDate: 'Start and end date',
    table: {
      vesselName: 'Ship Name',
      voyageNumber: 'Voyage No.',
      specialCode: 'Typhoon No.',
      specialName: 'Typhoon Name',
      vesselPosition: 'Current Position',
      vesselStatus: 'Dynamic',
      sailingCourse: 'Course',
      sailingSpeed: 'Speed',
      departPortName: 'Port of Departure',
      arrivePortName: 'Port of Destination',
      ladenType: 'Loading',
      typhoonPosition: 'Loading And Unloading',
      measuresInfo: 'Typhoon prevention plan or preventive measures taken',
      deviatedMeasure: 'Detour Measures',
      stopMeasure: 'Drift/Delay Measures',
      anchorWay: 'Anchor position/anchoring method (single anchor, one point anchor, eight point anchor)/chain length',
      deviceStatus: 'Working conditions of vehicle, rudder, motor, boiler and anchor equipment',
      otherMeasure: 'Other anti typhoon measures',
      remark: 'Remark'
    }
  },
  voyTyphoonSumStatistics: {
    home: 'Marine',
    title: 'List of Vessel Affected by Typhoon',
    filterName: 'Filter',
    queryVessel: 'Ship',
    tackValue: 'Typhoon No./Name',
    queryDate: 'Start and end date',
    table: {
      vesselName: 'Ship Name',
      voyageNumber: 'Voyage No.',
      trackCode: 'Typhoon No.',
      trackName: 'Typhoon Name',
      lossTime: 'Time lost due to anchoring, delay or detour of vessel or unit shutdown (hours)）',
      detourMileage: 'Ship Mileage (nautical miles)',
      additionalLoss: 'Additional fuel consumption due to avoidance measures (MT)',
      lossInfo: 'Suffer Losses',
      casualties: 'Casualties',
      pollutionInfo: 'Pollution Situation',
      equipmentInfo: 'Equipment Damage (name)',
      otherInfo: 'Others (specify)'
    }
  },
  voyTyphoonStatistics: {
    home: 'Marine',
    title: 'Typhoon Tracking Record',
    filterName: 'Filter',
    queryVessel: 'Ship',
    tackValue: 'Typhoon No./Name',
    queryDate: 'Start and end date',
    table: {
      vesselName: 'Ship Name',
      voyageNumber: 'Voyage No.',
      trackCode: 'Typhoon No.',
      trackName: 'Typhoon Name',
      reportDate: 'Report Date',
      anchorPosition: 'Position (anchor)',
      trackPosition: 'Typhoon Location',
      pressure: 'Pressure',
      maxWind: 'Maximum wind power of center accessories（m/s）',
      moveDirection: 'Direction of Movement',
      moveSpeed: 'Moving Speed',
      distance: 'Distance from typhoon center（nm）',
      quadrant: 'In the quadrant of Typhoon',
      currentWeather: 'On Site Weather',
      currentMeasures: 'Measures Taken',
      detourMileage: 'Detour Mileage',
      detourOil: 'Fuel consumption for detour',
      timeLoss: 'Time Loss'
    }
  },
  oilTransfer: {
    title: 'Oil Transfer',
    portCode: 'Port',
    actualStartDate: 'Start Date',
    actualEndDate: 'End Date',
    actualTrainStartDate: 'Training Date'
  }
};